/**
 * SPDX-License-Identifier: MPL-2.0
 * Copyright 2024 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2024 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2024 (c) Daniel Littfinski, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2004 (c) Marc Fischer, ISW University of Stuttgart (for umati and VDW e.V.)
 */

import React from 'react';
import { RootState } from 'index';
import { connect } from 'react-redux';

type StateProps_t = ReturnType<typeof mapStateToProps>;

function MsgList({ messages }: StateProps_t) {
  return (
    <div>
      {messages.map((m) => (
        <div key={m.id} className={`alert alert-${m.severity}`} role="alert">
          {m.msg}
        </div>
      ))}
    </div>
  );
}

const mapStateToProps = (state: RootState) => {
  return {
    messages: state.msgList.elements,
  };
};

export default connect(mapStateToProps)(MsgList);
